import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueAnnouncer from '@vue-a11y/announcer'
import './style.css'
import App from './App.vue'
import { i18n } from './plugins/i18n'
import router from './router'
import { loadConfig } from './config'
import { initializeAuth, registerAuthorizationFailureRedirect } from '@/auth/session'
import { configureChatAuthentication } from '@/auth/chatAuthentication'

loadConfig().then(async () => {
  const app = createApp(App)
  const pinia = createPinia()
  app.use(pinia)
  configureChatAuthentication(pinia, router)
  await initializeAuth()
  app.use(VueAnnouncer)
  app.use(i18n)
  app.use(router)
  registerAuthorizationFailureRedirect(router)
  app.mount('#app')
})
